export default {
  DEFAULT_WIDTH: '100%',
  DEFAULT_HEIGHT: 480,
  DEFAULT_OUTPUT: 'svg',
};
